import React, { useEffect, useState } from "react";
import { Button } from "../../components";
import useAuth from "../../hooks/useAuth";
import { FollowList, FollowingList } from "../../types/General";
import {
  useLazyGetFollowingListQuery,
  usePostFollowUnfollowMutation,
} from "../../service/Product";
import { STORAGE_KEYS, errorToast, getFromStorage } from "../../helpers";
import { useLazyGetProfileQuery } from "../../service/Auth";
import { useAppDispatch } from "../../hooks/store";
import { setCredentials } from "../../reducers/authSlice";

const TotalFollows = () => {
  const dispatch = useAppDispatch();
  const user = useAuth();
  const [follows, setFollows] = useState<FollowingList[]>([]);
  const [getFollowers, { isLoading }] = useLazyGetFollowingListQuery();
  const [postFollow, GetFollowData] = usePostFollowUnfollowMutation();
  const [getProfile] = useLazyGetProfileQuery();

  const getUserDetails = async () => {
    const token = getFromStorage(STORAGE_KEYS.token);
    try {
      const result = await getProfile({}).unwrap();
      if (result?.statusCode === 200) {
        dispatch(
          setCredentials({
            token: JSON.parse(`${token}`),
            user: result?.data || null,
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await getFollowers({
        userId: user?._id,
        type: 2,
      }).unwrap();
      if (response?.statusCode === 200) {
        setFollows(response?.data?.following || []);
      } else {
        setFollows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };
  const handleUnfollowUser = async (id: string) => {
    try {
      const response = await postFollow({
        user_id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        getUserDetails();
        fetchData();
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="main">
      <h2>Total Following</h2>
      <ul className="followers_lst">
        {follows?.length ? (
          follows?.map((item) => {
            return (
              <li className="flw_lst">
                <div className="lst_lft">
                  <figure className="delete_dv">
                    <img
                      src={
                        item?.following?.image ||
                        "/static/images/user_placeholder.png"
                      }
                      alt=""
                    />
                  </figure>
                  <h4>{item?.following?.fullName || ""}</h4>
                </div>
                <div className="lst_ryt">
                  <Button
                    value="Unfollow"
                    onClick={() => handleUnfollowUser(item?.following?._id)}
                  />
                </div>
              </li>
            );
          })
        ) : (
          <div className="no_followers_found">
            <p>You are not following anyone yet</p>
          </div>
        )}
      </ul>
    </div>
  );
};

export default TotalFollows;
